import React from "react";
import { Path } from "enums";
import { Route, Switch, Redirect } from "react-router-dom";
import PLBSingleInvoicingModule from "../modules/plb/single-invoicing/single-invoicing.module";
import PLBSingleInvoicingHistoryModule from "../modules/plb/single-invoicing/single-invoicing-history.module";

const PLBSingleInvoicingPage = () => {
  return (
    <Switch>
      <Route exact path={Path.PLBSingleInvoicingHistory} component={PLBSingleInvoicingHistoryModule} />
      <Route exact path={Path.PLBSingleInvoicing} component={PLBSingleInvoicingModule} />
      <Redirect to={Path.PLBSingleInvoicing} />
    </Switch>
  );
};

export default PLBSingleInvoicingPage;
